import React from 'react';
import PropTypes from 'prop-types';
import svg from 'shared/assets/icons/sprites/carCard.svg';

const SpriteIcon = params => {
  const { width, height, className, id, ...otherParams } = params;
  return (
    <svg width={width || 10} height={height || 10} className={className || ''} {...otherParams}>
      <use xlinkHref={`${svg}#${id}`} />
    </svg>
  );
};

SpriteIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
};

SpriteIcon.defaultProps = {
  width: '',
  height: '',
  className: '',
  id: '',
};

export default SpriteIcon;



// WEBPACK FOOTER //
// ./src/shared/components/Icons/SpriteIcon.js